import type {CancelablePromise} from '../types/CancelablePromise';
import type {TemplateV2} from '../types/TemplateV2';
import {request as __request} from '../utils/request';

export class GetTemplatesService {
  /**
   * @returns TemplateV2
   * @throws ApiError
   */
  public static getTemplates({
    documentKindCode,
    authorization,
  }: {
    documentKindCode?: string;
    authorization?: string;
  }): CancelablePromise<Array<TemplateV2>> {
    return __request({
      method: 'GET',
      url: '/dms/v2/document/templates',
      headers: {
        Authorization: authorization,
      },
      query: {
        documentKindCode,
      },
      shouldClearCacheEntry: true,
    });
  }
}
